var _defs, _circle, _rect, _path, _circle2, _circle3, _circle4, _path2, _circle5, _circle6, _circle7, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRagBotRedefined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 8,
    y1: 8,
    x2: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1D4ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C55E"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 20,
    stroke: "url(#g1)",
    strokeWidth: 3,
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 24,
    height: 18,
    rx: 6,
    fill: "url(#g1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 12V16",
    stroke: "url(#g1)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 10,
    r: 2.5,
    fill: "#22C55E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 25,
    r: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29C26 31 32 31 34 29",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 42,
    r: 3,
    fill: "url(#g1)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 46,
    r: 3,
    fill: "url(#g1)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 42,
    r: 3,
    fill: "url(#g1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 39L24 34",
    stroke: "url(#g1)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43L29 36",
    stroke: "url(#g1)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39L34 34",
    stroke: "url(#g1)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38L31 42L35 43L32 46L33 50L29 48L25 50L26 46L23 43L27 42Z",
    fill: "#22C55E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRagBotRedefined);
export default __webpack_public_path__ + "static/media/RAG_Bot_Redefined.ff950b8851c4ac3a1a212a9c2da0e11c.svg";
export { ForwardRef as ReactComponent };